import { _get, _put } from "../../http";

// Configuración de NIA por libro. La ausencia de documento es "NIA apagado":
// el director editorial habilita los libros de forma explícita desde el gestor.

// Catálogo del gestor: los libros liberados de la editorial con su bandera ya
// resuelta. Devuelve sólo lo que la pantalla pinta (título, portada,
// clasificación y `habilitado`), por eso no reusa el endpoint de portadas.
export const getNiaLibrosCatalogo = () => _get(`/lia-api/nia-libros/catalogo`);

// Un libro suelto: siempre responde { libro, habilitado }, nunca 404.
export const getNiaLibro = (libroId) => _get(`/lia-api/nia-libros/${libroId}`);

export const setNiaLibro = (libroId, habilitado) => _put(`/lia-api/nia-libros/${libroId}`, { habilitado });

export const setNiaLibrosVarios = (libroIds, habilitado) => _put(`/lia-api/nia-libros`, { libroIds, habilitado });
